import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import type { Entity } from '../../../../core/models/entity.model';
import { EntityTypeKey } from '../../../../shared/constants/entity-type-keys';

@Component({
  selector: 'app-product-message-link',
  templateUrl: './product-message-link.component.html',
  styleUrls: ['./product-message-link.component.scss'],
  standalone: false
})
export class ProductMessageLinkComponent implements OnChanges {
  @Input() parentEntity: Entity;
  @Input() level: number;
  @Input() isPrice: boolean;

  protected routerLink: string[] = ['./'];
  protected routerLinkParams: Record<string, any> = {};

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['parentEntity']?.currentValue) {
      const isProject = this.parentEntity.EntityTypeKey === EntityTypeKey.Project;

      if (isProject) {
        this.routerLink = ['/projects', this.parentEntity.Id];
        this.routerLinkParams = {};
      } else if (this.isPrice) {
        this.routerLink = ['/projects', this.parentEntity.ParentId, 'prices'];
        this.routerLinkParams = {};
      } else {
        this.routerLink = ['./'];
        this.routerLinkParams = { selectedId: this.parentEntity.Id };
      }
    }
  }

  isChildMessage(message: Entity): boolean {
    return message.EntityTypeKey !== EntityTypeKey.GastroFlowHood && message.EntityTypeKey !== EntityTypeKey.Project;
  }
}
